import React from 'react';
import useClasses from '../../hooks/useClasses';
import './style.scss';

type Option = {
  label: string;
  value: string;
};

type Props = {
  id: string;
  label: string;
  hint?: string;
  type: 'binary' | 'multichoice';
  options: Option[];
  selectedValue?: string;
  onChange: (value: string) => void;
  error?: string;
};

const ToggleGroup: React.FC<Props> = ({
  id,
  label,
  hint,
  type,
  options,
  selectedValue,
  onChange,
  error,
}) => {
  const { buildClass } = useClasses('ToggleGroup');
  const errorId = `${id}-error`;

  return (
    <div className={buildClass()}>
      <fieldset aria-describedby={error ? errorId : undefined}>
        <legend className={buildClass('label')}>{label}</legend>
        {hint && (
          <p className={buildClass('hint')}>{hint}</p>
        )}
        <div className={buildClass('options', { [type]: true })}>
          {options.map((option) => (
            <div key={option.value} className={buildClass('radio')}>
              <input
                type="radio"
                name={id}
                id={`${id}-${option.value}`}
                value={option.value}
                checked={selectedValue === option.value}
                onChange={() => onChange(option.value)}
              />
              <label htmlFor={`${id}-${option.value}`}>
                {option.label}
              </label>
            </div>
          ))}
        </div>
        {error && (
          <div className="FormElement__error" id={errorId} aria-live="assertive">
            {error}
          </div>
        )}
      </fieldset>
    </div>
  );
};

export default ToggleGroup;
